export default "/images/vendor/flag-icon-css/flags/4x3/ky.svg?ef8e18776eff1caf6b648c5c29847b64";